/**
 * Защита от параллельного редактирования (ТЗ FR-05).
 *
 * Если дело открыто другим пользователем, второй получает предупреждение
 * и режим только для чтения. Блокировка живёт две минуты и продлевается,
 * пока вкладка открыта: закрытая вкладка освобождает дело сама.
 *
 * Блокировка живёт в таблице серверной части: она видит всех пользователей
 * сразу и снимает истёкшую сама. Пользователя сервер определяет по ключу
 * сеанса, поэтому передавать его идентификатор из браузера не нужно —
 * подставить чужой было бы нельзя.
 */

import { useEffect, useState } from 'react';
import { api } from '../../api.js';

export interface LockState {
  readOnly: boolean;
  heldBy: string | null;
  checked: boolean;
}

const RENEW_INTERVAL = 60_000;

export function useLock(caseId: string, user: { id: string; name: string } | null): LockState {
  const [state, setState] = useState<LockState>({ readOnly: false, heldBy: null, checked: false });

  useEffect(() => {
    if (!user) return;
    let cancelled = false;

    const acquire = async () => {
      try {
        const result = await api.lock(caseId);
        if (cancelled) return;
        setState({ readOnly: result.readOnly, heldBy: result.heldBy, checked: true });
      } catch {
        // Недоступность сервера не должна запирать карточку: профиль
        // пишется прямо в портал и сохранится без блокировки
        if (!cancelled) setState({ readOnly: false, heldBy: null, checked: true });
      }
    };

    void acquire();
    const timer = setInterval(acquire, RENEW_INTERVAL);

    const release = () => {
      void api.unlock(caseId).catch(() => undefined);
    };
    window.addEventListener('beforeunload', release);

    return () => {
      cancelled = true;
      clearInterval(timer);
      window.removeEventListener('beforeunload', release);
      release();
    };
  }, [caseId, user?.id]);

  return state;
}
